import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Notification} from './models/notification.model';
import {NotificationFacade} from './facade/notification.facade';
import {tap} from 'rxjs/operators';

@Component({
  selector: 'morva-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnChanges {
  @Input() workspaceId: string;
  notifications: Notification[];
  unSeenCount = 0;
  isSeen: boolean;

  constructor(private notificationFacade: NotificationFacade) {
  }

  ngOnInit(): void {
    this.setSubscribers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['workspaceId'] && this.workspaceId !== null) {
      this.isSeen = false;
      this.notificationFacade.loadNotifications(this.workspaceId);
    }
  }

  setSubscribers(): void {
    this.notificationFacade.getNotifications$().
    pipe(tap(notifications => this.notifications = notifications)).subscribe();
    this.notificationFacade.getUnSeenCount$().
    pipe(tap(unSeenCount => this.unSeenCount = unSeenCount)).subscribe();
  }

  deleteNotification(notificationId: string, event) {
    event.stopPropagation();
    this.notificationFacade.deleteNotification(this.workspaceId, notificationId);
  }

  seenNotifications() {
    const notificationIds = [];
    if(!this.isSeen) {
      this.notifications.forEach(notification => {
        if(!notification.seen) {
          notificationIds.push(notification.notificationId);
        }
      });
      if(notificationIds.length > 0) {
        this.notificationFacade.updateSeenNotifications(this.workspaceId,notificationIds);
      }
      this.isSeen = true;
    }
  }
}
